import React, { useState, useRef, useEffect } from "react";
import { Card, Input, Select, Button, Modal } from "../../../../../common";
import { useSelector } from "react-redux";
import { fetchStates, fetchCities } from "../../../../../../utils/Helper";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import {
  useCreateAddressDetailsMutation,
  useCreateAddressMutation,
  useCreateAddressDetailsUpdateMutation,
  useCreateAddressDetailsDraftMutation, useEditAddressDetailsDraftMutation
} from "../../../../../../store/Company/companyApiSlice";
import { isVerified } from "../../../../../../utils/Helper";
import { countryCodes } from "../../../profile/countryCodes";
import useCompanyUpdate from "../useCompanyFollowUpdate"
import { getCitiesByCountryCodeAndStateName, getCountryCode, getStatesByCountryCode, extractCountryCodeAndPhoneCode } from "../../../../../../utils/countriesState";
import PhoneNumberInput from "../../../../../common/PhoneNumberInput";
import WorkingHoursUI from "../../../../../common/WorkingHoursUI";

const workingHours = [
  "7:00 AM - 3:00 PM",
  "8:00 AM - 3:00 PM",
  "8:00 AM - 4:00 PM",
  "8:00 AM - 5:00 PM",
  "8:00 AM - 6:00 PM",
  "8:30 AM - 5:30 PM",
  "9:00 AM - 5:00 PM",
  "9:00 AM - 6:00 PM",
  "9:00 AM - 7:00 PM",
  "10:00 AM - 6:00 PM",
  "10:00 AM - 7:00 PM",
];

export const NewAddressForm = ({ address, primaryAddress, modalHandle, refetch, edit = false }) => {
  const houseNoRef = useRef();
  const localityRef = useRef();
  const areaRef = useRef();
  const postalCodeRef = useRef();
  const emailRef = useRef();
  const [mobile, setMobile] = useState("");
  // const telephoneRef = useRef();
  const cityRef = useRef();
  const [selectedHours, setSelectedHours] = useState(address?.working_hours || "Monday to Friday 9AM to 6PM");
  const [postalCodeError, setPostalCodeError] = useState("");
  const [countries, setCountries] = useState(getCountryCode());
  const [countryCodes, setCountryCodes] = useState(extractCountryCodeAndPhoneCode());
  const [cityError, setCityError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [errors, setErrors] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [countryCode, setCountryCode] = useState("+971");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(
    address?.country || ""
  );
  const [primaryAdd, setPrimaryAdd] = useState(false);
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);

  const [createAddressDetails, { isLoading }] =
    useCreateAddressDetailsMutation();
  const [setAddressConnection] = useCreateAddressMutation();
  const [addressDetailsUpdate, { isLoading: isUpdatingAddress }] =
    useCreateAddressDetailsUpdateMutation();

  const [createAddressDetailsDraft, { isLoading: isDraftingAddress }] =
    useCreateAddressDetailsDraftMutation();

  const [editAddressDetailsDraft] = useEditAddressDetailsDraftMutation();

  const handleUpdateCompany = useCompanyUpdate();

  useEffect(() => {
    if (address) {
      houseNoRef.current.value = address?.address_line_1 || "";
      localityRef.current.value = address?.address_line_2 || "";
      areaRef.current.value = address?.area || "";
      postalCodeRef.current.value = address?.postal_code || "";
      emailRef.current.value = address?.email || "";
      setMobile(address?.telephone || "");
      setCountryCode(address?.telephone?.split("|")[0] || "+971")
      cityRef.current.value = address?.city || "";

      const selectedCountryData = countries.find(
        (country) => country.countryCode === address?.country
      );


      if (selectedCountryData) {
        let statesFn = async () => {
          // let states = await fetchStates(selectedCountryData.geonameId);
          const states = await getStatesByCountryCode(selectedCountryData?.countryCode)
          setStates(states);
          setSelectedState(address.state);
          if (states?.length > 0) {
            const selectedStateObj = states?.find(
              (state) => state.name === address.state
            );
            if (selectedStateObj) {
              let cityFn = async () => {
                // let cities = await fetchCities(selectedStateObj.geonameId);
                setCities(getCitiesByCountryCodeAndStateName(selectedCountry, selectedStateObj.name));
                setSelectedCity(address.city);
              };
              cityFn();
            }
          }
        };
        statesFn();
      }
    }
  }, [address]);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    const selectedCountryData = countries.find(
      (country) => country.countryCode === e.target.value
    );

    if (selectedCountryData) {
      let statesFn = async () => {
        const states = await getStatesByCountryCode(selectedCountryData?.countryCode);
        setStates(states);
        setSelectedState(selectedState);
      };
      statesFn();
    }
  };



  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setSelectedState(selectedState);
    setCities(getCitiesByCountryCodeAndStateName(selectedCountry, selectedState));
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setSelectedCity(selectedCity);
  };


  const handlePrimaryAddress = () => {
    setPrimaryAdd(!primaryAdd);
  };

  const handleWorkingHours = (e) => {
    setSelectedHours(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setModalOpen(true);
    const newErrors = {}
    if (houseNoRef.current.value.trim() === "") {
      newErrors.houseNo = "Address Line 1 is required.";
    }
    if (mobile.trim() === "") {
      newErrors.phone = "Phone number is required.";
    }
    if (cityRef.current.value.trim() === "") {
      newErrors.city = "City is required.";
    }
    if (selectedState.trim() === "") {
      newErrors.state = "State is required.";
    }
    if (selectedCountry.trim() === "") {
      newErrors.country = "Country is required.";
    }
    if (selectedHours === "") {
      newErrors.workingHours = "Working Hours is required.";
    }
    if (emailRef.current.value.trim() === "") {
      newErrors.email = "Email Address is required.";
    } else if (!isValidEmail(emailRef.current.value.trim())) {
      newErrors.email = "Invalid Email Address.";
    }
    setErrors(newErrors);
    setPostalCodeError(newErrors.postalCode || "");
    setCityError(newErrors.city || "");
    setEmailError(newErrors.email || "");
    setPhoneNumberError(newErrors.phone || "");
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    const verifiedData = currentEditingCompany.verifiedCompany;
    if (isVerified(verifiedData)) {
      try {
        if (address?.company_address_details_draftID) {
          let data;
          if (address?.company_address_detailsID_id != undefined && address?.company_address_detailsID_id != null) {
            data = {
              company_address_detailsID: address?.company_address_detailsID_id,
              address_line_1: houseNoRef.current.value,
              address_line_2: localityRef.current.value ? localityRef.current.value : null,
              postal_code: postalCodeRef.current.value,
              area: areaRef.current.value ? areaRef.current.value : null,
              city: cityRef.current.value,
              state: selectedState,
              country: selectedCountry,
              working_hours: selectedHours,
              telephone: mobile,
              email: emailRef.current.value,
              request_type: "company details created",
              current_companyID: currentEditingCompany.companyID,
            }
          } else {
            data = {
              address_line_1: houseNoRef.current.value,
              address_line_2: localityRef.current.value ? localityRef.current.value : null,
              postal_code: postalCodeRef.current.value,
              area: areaRef.current.value ? areaRef.current.value : null,
              city: cityRef.current.value,
              state: selectedState,
              country: selectedCountry,
              working_hours: selectedHours,
              telephone: mobile,
              email: emailRef.current.value,
              request_type: "company details created",
              current_companyID: currentEditingCompany.companyID,
            }
          }
          const res = await editAddressDetailsDraft({
            data: data,
            token,
            company_address_details_draftID: address?.company_address_details_draftID,
          }).unwrap();
        } else {
          let data;
          if (address?.company_address_detailsID != undefined && address?.company_address_detailsID != null) {
            data = {
              company_address_detailsID: address?.company_address_detailsID,
              address_line_1: houseNoRef.current.value,
              address_line_2: localityRef.current.value ? localityRef.current.value : null,
              postal_code: postalCodeRef.current.value,
              area: areaRef.current.value ? areaRef.current.value : null,
              city: cityRef.current.value,
              state: selectedState,
              country: selectedCountry,
              working_hours: selectedHours,
              telephone: mobile,
              email: emailRef.current.value,
              request_type: "company details created",
              current_companyID: currentEditingCompany.companyID,
            }
          } else {
            data = {
              address_line_1: houseNoRef.current.value,
              address_line_2: localityRef.current.value ? localityRef.current.value : null,
              postal_code: postalCodeRef.current.value,
              area: areaRef.current.value ? areaRef.current.value : null,
              city: cityRef.current.value,
              state: selectedState,
              country: selectedCountry,
              working_hours: selectedHours,
              telephone: mobile,
              email: emailRef.current.value,
              request_type: "company details created",
              current_companyID: currentEditingCompany.companyID,
            }
          }
          const res = await createAddressDetailsDraft({
            data: data,
            token,
            company_address_detailsID: address?.company_address_detailsID,
          }).unwrap();
        }

      } catch (error) {
      } finally {
        refetch()
        modalHandle();
        // window.location.reload()
      }
      return;
    } else if (address) {
      try {
        const res = await addressDetailsUpdate({
          data: {
            address_line_1: houseNoRef.current.value,
            address_line_2: localityRef.current.value,
            postal_code: postalCodeRef.current.value,
            area: areaRef.current.value,
            city: cityRef.current.value,
            state: selectedState,
            country: selectedCountry,
            working_hours: selectedHours,
            telephone: mobile,
            email: emailRef.current.value,
          },
          token,
          company_address_detailsID: address?.company_address_detailsID,
        }).unwrap();

        if (res) {
          const result = await handleUpdateCompany(currentEditingCompany.companyID, "Address Details Updated", token);
          if (!result.success) {
            console.error(result.error);
          }
        }
      } catch (error) {

      } finally {
        modalHandle();
        window.location.reload()

      }
    } else {
      try {
        const res = await createAddressDetails({
          data: {
            address_line_1: houseNoRef.current.value,
            address_line_2: localityRef.current.value,
            postal_code: postalCodeRef.current.value,
            area: areaRef.current.value,
            city: cityRef.current.value,
            state: selectedState,
            country: selectedCountry,
            working_hours: selectedHours,
            telephone: mobile,
            email: emailRef.current.value,
          },
          token,
        }).unwrap();


        if (res) {
          const addressData = await setAddressConnection({
            data: {
              primary_address: primaryAdd,
              company_address_detailsID: res.company_address_detailsID,
              companyID: currentEditingCompany.companyID,
            },
            token,
            companyId: currentEditingCompany.companyID,
          }).unwrap();

          if (addressData) {
          }
          const result = await handleUpdateCompany(currentEditingCompany.companyID, "New Address Added", token);
          if (!result.success) {
            console.error(result.error);
          }
        }
      } catch (error) {

      } finally {
        modalHandle();
        window.location.reload()

      }
    }
  };

  return (
    <Card classes="rounded bg-white p-4 w-[42rem] overflow-scroll max-h-[80vh] overflow-x-hidden">
      <h5 className="text-f18 text-secondarytwo text-left mb-4">
        {edit ? "Update Address" : "Add New Address"}
      </h5>

      <div className="">
        <div className="flex gap-4 w-full">
          <Input
            label="Address Line 1"
            id="houseNo"
            inputRef={houseNoRef}
            error={errors.houseNo}
            placeholder="Suite/Building/Floor No."
          />
          <Input
            label="Address Line 2"
            id="locality"
            inputRef={localityRef}
            error={errors.locality}
            placeholder="Enter Street/Locality"
          />
        </div>
        <div className="flex gap-4 w-full">
          <Input
            label="Area"
            id="area"
            inputRef={areaRef}
            error={errors.area}
            placeholder="Enter Area"
          />
          <Input
            label="Postal Code"
            id="postalCode"
            inputRef={postalCodeRef}
            error={postalCodeError}
            placeholder="Enter Postal Code"
          />
        </div>

        <div className="flex gap-4 w-full">
          <Select
            label="Country"
            id="country"
            value={selectedCountry}
            error={errors.country}
            placeholder="Select a country"
            onChange={handleCountryChange}
          >
            <option value="" disabled={address != null && address?.country != '' && true}>Select a country</option>
            {countries?.map((country) => (
              <option disabled={address != null && address?.country != '' && true} key={country.countryName} value={country.countryCode}>
                {country.countryName}
              </option>
            ))}
          </Select>
          {/* <Select
            label="Working Hours"
            id="hours"
            value={selectedHours}
            error={errors.workingHours}
            placeholder="Select a hours"
            onChange={handleWorkingHours}
          >
            <option value="">Select a working hours</option>
            {workingHours?.map((hours) => (
              <option key={hours} value={hours}>
                {hours}
              </option>
            ))}
          </Select> */}
        </div>
        <div className="flex gap-4 w-full">
          {states?.length > 0 ? <Select
            label="State"
            id="state"
            value={selectedState}
            onChange={handleStateChange}
            error={errors.state}
            placeholder="Select a state"
          >
            <option value="">Select a state</option>
            {states?.map((state) => (
              <option key={state.state_code} value={state.name}>
                {state.name}
              </option>
            ))}
          </Select> : <Input
            label="State"
            id="state"
            inputvalue={selectedState}
            onInputChange={handleStateChange}
            error={errors.state}
            placeholder="Enter a state"
            disable={!selectedCountry}
            className={!selectedCountry ? "cursor-not-allowed" : "default"}
          />}
          <Input
            label="City"
            id="city"
            inputRef={cityRef}
            error={cityError}
            placeholder="Enter a City"
          />
        </div>
        <div className="flex gap-4 w-full">
          <Input
            label="Email Address"
            id="email"
            inputRef={emailRef}
            error={emailError}
            placeholder="Email Address"
          />
          <div className="flex items-start flex-col relative w-full">
            <div className="flex items-start flex-col w-full">
              <label className="text-primary text-f14 font-semibold text-left mb-1">
                Phone
              </label>
              <div className="relative w-full">
                <PhoneNumberInput
                  id="mobile"
                  phone={mobile}
                  border={true}
                  setPhone={setMobile}
                  verifyPhoneNumber={false}
                  classes={'addBackground'}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-4 w-full">
          <WorkingHoursUI selectedTime={selectedHours} setSelectedTime={setSelectedHours} error={errors.workingHours} />
        </div>
        <Button
          onClick={handleSubmit}
          classes="w-full p-2 bg-primary text-white rounded text-f18 mt-4 flex justify-center"
        >
          {isLoading || isUpdatingAddress || isDraftingAddress ? (
            <Spinner />
          ) : (
            "Save"
          )}
        </Button>
      </div>
    </Card>
  );
};
const isValidEmail = (email) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
};
